export default __webpack_public_path__ + "static/media/todosHaiti.12bfc71b.png";